import { AlertCircle } from 'lucide-react';

import { useFocusRequest } from './use-focus-request';

import '../venue-booking-content.css';

export interface PhotoErrorNoticeProps {
  message: string;
  /** The file that was turned down, or null when no file was the cause. */
  fileLabel: string | null;
  phone: boolean;
  focusRequested: boolean;
  onFocused: () => void;
  onDismiss: () => void;
}

/** Why a photo change did not go through. The photo on the venue is unchanged. */
export function PhotoErrorNotice({
  message,
  fileLabel,
  phone,
  focusRequested,
  onFocused,
  onDismiss,
}: PhotoErrorNoticeProps) {
  const alert = useFocusRequest<HTMLDivElement>(focusRequested, onFocused);
  const dismissSize = phone ? 44 : 24;
  return (
    <div
      ref={alert}
      tabIndex={-1}
      role="alert"
      className="vbc-error"
      style={{
        borderRadius: 10,
        padding: '10px 12px',
        display: 'flex',
        gap: 9,
        alignItems: 'flex-start',
      }}
    >
      <span style={{ display: 'flex', marginTop: 1 }}>
        <AlertCircle size={15} aria-hidden="true" />
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 12.5, fontWeight: 700, lineHeight: 1.4 }}>{message}</div>
        <div style={{ fontSize: 11, marginTop: 2, color: 'var(--nb-muted)', lineHeight: 1.45 }}>
          {fileLabel ? (
            <>
              <span className="nb-mono" style={{ fontSize: 10.5 }}>
                {fileLabel}
              </span>{' '}
              wasn&apos;t uploaded. The current photo hasn&apos;t changed.
            </>
          ) : (
            <>Nothing was uploaded. The current photo hasn&apos;t changed.</>
          )}
        </div>
      </div>
      <button
        type="button"
        className="nb-btn nb-btn-ghost"
        title="Dismiss"
        aria-label="Dismiss message"
        onClick={onDismiss}
        style={{
          width: dismissSize,
          height: dismissSize,
          padding: 0,
          justifyContent: 'center',
          fontSize: 15,
          color: 'inherit',
        }}
      >
        ×
      </button>
    </div>
  );
}
